module.exports = __webpack_public_path__ + "img/onborad1.b4c96b26.png";